import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue";
var _hoisted_1 = ["onClick"];
var _hoisted_2 = ["src"];
var _hoisted_3 = ["src"];
var _hoisted_4 = ["src"];
var _hoisted_5 = {
  "class": "emoji-picker-tab"
};
var _hoisted_6 = ["onClick"];
var _hoisted_7 = ["src"];
var _hoisted_8 = ["src"];
import { TUIChatService, TUIStore, StoreName } from "@tencentcloud/chat-uikit-engine";
import { ref } from "../../../../adapter-vue";
import { emojiList, basicEmojiMap } from "../../utils/emojiList";
import { EMOJI_TYPE } from ".././../../../constant";
import Icon from "../../../common/Icon.vue";
import faceIcon from "../../../../assets/icon/face.png";
import { isPC, isUniFrameWork } from "../../../../utils/env";
import { isEnabledMessageReadReceiptGlobal } from "../../utils/utils";
export default /*@__PURE__*/_defineComponent({
  __name: 'emoji-picker-dialog',
  emits: ["insertEmoji", "onClose", "sendMessage"],
  setup: function setup(__props, _ref) {
    var _list$value$;
    var __emit = _ref.emit;
    var emits = __emit;
    var list = ref(emojiList);
    var currentTabIndex = ref(0);
    var currentTabItem = ref(list === null || list === void 0 ? void 0 : list.value[0]);
    var currentEmojiList = ref(list === null || list === void 0 || (_list$value$ = list.value[0]) === null || _list$value$ === void 0 ? void 0 : _list$value$.list);
    var _currentConversation = ref();
    var emojiPickerDialog = ref();
    var emojiPickerListRef = ref();
    TUIStore.watch(StoreName.CONV, {
      currentConversation: function currentConversation(conversation) {
        _currentConversation.value = conversation;
      }
    });
    var toggleEmojiTab = function toggleEmojiTab(index) {
      var _list$value$index;
      currentTabIndex.value = index;
      currentTabItem.value = list === null || list === void 0 ? void 0 : list.value[index];
      currentEmojiList.value = list === null || list === void 0 || (_list$value$index = list.value[index]) === null || _list$value$index === void 0 ? void 0 : _list$value$index.list;
      // 滚动条回滚到顶部
      // 原生 web & h5
      if (!isUniFrameWork) {
        (emojiPickerListRef === null || emojiPickerListRef === void 0 ? void 0 : emojiPickerListRef.value) && (emojiPickerListRef.value.scrollTop = 0);
      }
    };
    var select = function select(item, index) {
      var _currentTabItem$value, _currentTabItem$value2, _currentTabItem$value3;
      var options = {
        name: item,
        type: currentTabItem === null || currentTabItem === void 0 || (_currentTabItem$value = currentTabItem.value) === null || _currentTabItem$value === void 0 ? void 0 : _currentTabItem$value.type
      };
      switch (currentTabItem === null || currentTabItem === void 0 || (_currentTabItem$value2 = currentTabItem.value) === null || _currentTabItem$value2 === void 0 ? void 0 : _currentTabItem$value2.type) {
        case EMOJI_TYPE.BASIC:
          options.url = (currentTabItem === null || currentTabItem === void 0 || (_currentTabItem$value3 = currentTabItem.value) === null || _currentTabItem$value3 === void 0 ? void 0 : _currentTabItem$value3.url) + basicEmojiMap[item];
          emits("insertEmoji", options);
          break;
        case EMOJI_TYPE.BIG:
          sendFaceMessage(index, currentTabItem.value);
          break;
        case EMOJI_TYPE.CUSTOM:
          sendFaceMessage(index, currentTabItem.value);
          break;
        default:
          break;
      }
      isPC && emits("onClose");
    };
    var sendFaceMessage = function sendFaceMessage(index, listItem) {
      var _currentConversation$, _currentConversation$2, _currentConversation$3;
      var options = {
        to: (_currentConversation === null || _currentConversation === void 0 || (_currentConversation$ = _currentConversation.value) === null || _currentConversation$ === void 0 || (_currentConversation$ = _currentConversation$.groupProfile) === null || _currentConversation$ === void 0 ? void 0 : _currentConversation$.groupID) || (_currentConversation === null || _currentConversation === void 0 || (_currentConversation$2 = _currentConversation.value) === null || _currentConversation$2 === void 0 || (_currentConversation$2 = _currentConversation$2.userProfile) === null || _currentConversation$2 === void 0 ? void 0 : _currentConversation$2.userID),
        conversationType: _currentConversation === null || _currentConversation === void 0 || (_currentConversation$3 = _currentConversation.value) === null || _currentConversation$3 === void 0 ? void 0 : _currentConversation$3.type,
        payload: {
          index: listItem.index,
          data: listItem.list[index]
        },
        needReadReceipt: isEnabledMessageReadReceiptGlobal()
      };
      TUIChatService.sendFaceMessage(options);
    };
    var sendMessage = function sendMessage() {
      emits("sendMessage");
    };
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        "class": _normalizeClass(['emoji-picker', !_unref(isPC) && 'emoji-picker-h5']),
        ref_key: "emojiPickerDialog",
        ref: emojiPickerDialog
      }, [_createElementVNode("ul", {
        "class": _normalizeClass(['emoji-picker-list', !_unref(isPC) && 'emoji-picker-h5-list']),
        ref_key: "emojiPickerListRef",
        ref: emojiPickerListRef
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currentEmojiList), function (childrenItem, childrenIndex) {
        return _openBlock(), _createElementBlock("li", {
          "class": "emoji-picker-list-item",
          key: childrenIndex,
          onClick: function onClick($event) {
            return select(childrenItem, childrenIndex);
          }
        }, [_unref(currentTabItem).type === _unref(EMOJI_TYPE).BASIC ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          "class": "emoji",
          src: _unref(currentTabItem).url + _unref(basicEmojiMap)[childrenItem]
        }, null, 8, _hoisted_2)) : _unref(currentTabItem).type === _unref(EMOJI_TYPE).BIG ? (_openBlock(), _createElementBlock("img", {
          key: 1,
          "class": "emoji-big",
          src: _unref(currentTabItem).url + childrenItem + '@2x.png'
        }, null, 8, _hoisted_3)) : (_openBlock(), _createElementBlock("img", {
          key: 2,
          "class": "emoji-custom",
          src: _unref(currentTabItem).url + childrenItem
        }, null, 8, _hoisted_4))], 8, _hoisted_1);
      }), 128))], 2), _createElementVNode("ul", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list), function (item, index) {
        return _openBlock(), _createElementBlock("li", {
          "class": "emoji-picker-tab-item",
          key: index,
          onClick: function onClick($event) {
            return toggleEmojiTab(index);
          }
        }, [item.type === _unref(EMOJI_TYPE).BASIC ? (_openBlock(), _createBlock(Icon, {
          key: 0,
          "class": "icon",
          file: _unref(faceIcon)
        }, null, 8, ["file"])) : item.type === _unref(EMOJI_TYPE).BIG ? (_openBlock(), _createElementBlock("img", {
          key: 1,
          "class": "icon-big",
          src: item.url + item.list[0] + '@2x.png'
        }, null, 8, _hoisted_7)) : (_openBlock(), _createElementBlock("img", {
          key: 2,
          "class": "icon-custom",
          src: item.url + item.list[0]
        }, null, 8, _hoisted_8))], 8, _hoisted_6);
      }), 128)), _unref(isUniFrameWork) ? (_openBlock(), _createElementBlock("li", {
        key: 0,
        "class": "send-btn",
        onClick: sendMessage
      }, "发送")) : _createCommentVNode("", true)])], 2);
    };
  }
});